/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssignmentPriority } from './AssignmentPriority';
import {
    AssignmentPriorityFromJSON,
    AssignmentPriorityFromJSONTyped,
    AssignmentPriorityToJSON,
    AssignmentPriorityToJSONTyped,
} from './AssignmentPriority';
import type { AssignmentStatus } from './AssignmentStatus';
import {
    AssignmentStatusFromJSON,
    AssignmentStatusFromJSONTyped,
    AssignmentStatusToJSON,
    AssignmentStatusToJSONTyped,
} from './AssignmentStatus';

/**
 * 
 * @export
 * @interface AssignmentResponse
 */
export interface AssignmentResponse {
    /**
     * 
     * @type {string}
     * @memberof AssignmentResponse
     */
    assignmentId: string;
    /**
     * 
     * @type {AssignmentPriority}
     * @memberof AssignmentResponse
     */
    priority: AssignmentPriority;
    /**
     * 
     * @type {string}
     * @memberof AssignmentResponse
     */
    description: string;
    /**
     * 
     * @type {Date}
     * @memberof AssignmentResponse
     */
    dueDate: Date;
    /**
     * 
     * @type {string}
     * @memberof AssignmentResponse
     */
    assignedCounselorId: string;
    /**
     * 
     * @type {AssignmentStatus}
     * @memberof AssignmentResponse
     */
    status: AssignmentStatus;
    /**
     * 
     * @type {Date}
     * @memberof AssignmentResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssignmentResponse
     */
    statusUpdatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof AssignmentResponse
     */
    assignedClientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentResponse
     */
    assignedClientFullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentResponse
     */
    assignedCaseNoteId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentResponse
     */
    assignedCaseNoteLabel?: string | null;
}



/**
 * Check if a given object implements the AssignmentResponse interface.
 */
export function instanceOfAssignmentResponse(value: object): value is AssignmentResponse {
    if (!('assignmentId' in value) || value['assignmentId'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('assignedCounselorId' in value) || value['assignedCounselorId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('statusUpdatedAt' in value) || value['statusUpdatedAt'] === undefined) return false;
    return true;
}

export function AssignmentResponseFromJSON(json: any): AssignmentResponse {
    return AssignmentResponseFromJSONTyped(json, false);
}

export function AssignmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'assignmentId': json['assignmentId'],
        'priority': AssignmentPriorityFromJSON(json['priority']),
        'description': json['description'],
        'dueDate': (new Date(json['dueDate'])),
        'assignedCounselorId': json['assignedCounselorId'],
        'status': AssignmentStatusFromJSON(json['status']),
        'createdAt': (new Date(json['createdAt'])),
        'statusUpdatedAt': (new Date(json['statusUpdatedAt'])),
        'assignedClientId': json['assignedClientId'] == null ? undefined : json['assignedClientId'],
        'assignedClientFullName': json['assignedClientFullName'] == null ? undefined : json['assignedClientFullName'],
        'assignedCaseNoteId': json['assignedCaseNoteId'] == null ? undefined : json['assignedCaseNoteId'],
        'assignedCaseNoteLabel': json['assignedCaseNoteLabel'] == null ? undefined : json['assignedCaseNoteLabel'],
    };
}

export function AssignmentResponseToJSON(json: any): AssignmentResponse {
    return AssignmentResponseToJSONTyped(json, false);
}

export function AssignmentResponseToJSONTyped(value?: AssignmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignmentId': value['assignmentId'],
        'priority': AssignmentPriorityToJSON(value['priority']),
        'description': value['description'],
        'dueDate': value['dueDate'].toISOString(),
        'assignedCounselorId': value['assignedCounselorId'],
        'status': AssignmentStatusToJSON(value['status']),
        'createdAt': value['createdAt'].toISOString(),
        'statusUpdatedAt': value['statusUpdatedAt'].toISOString(),
        'assignedClientId': value['assignedClientId'],
        'assignedClientFullName': value['assignedClientFullName'],
        'assignedCaseNoteId': value['assignedCaseNoteId'],
        'assignedCaseNoteLabel': value['assignedCaseNoteLabel'],
    };
}

